export interface DocketRow {
  id: number;
  agencyName: string;
  titleNumber?: number;
  chapterNumber: string;
  description: string;
  hearingNoticeReceivedDates: Date[];
  scheduleHearingDates: Date[];
  agReceivedDate?: Date;
  agDecisionDate?: Date;
  gproReceivedDate?: Date;
  gproDecisionDate?: Date;
  sosFiledDate?: Date;
  effectiveDate?: Date;
}

export const ConstructEmptyDocketRow = () => {
  let docketRow = {
    id: -1,
    titleNumber: -1,
    chapterNumber: "",
    description: "",
    hearingNoticeReceivedDates: [],
    scheduleHearingDates: [],
    agReceivedDate: new Date(),
    agDecisionDate: new Date(),
    gproReceivedDate: new Date(),
    gproDecisionDate: new Date(),
    sosFiledDate: new Date(),
    effectiveDate: new Date(),
  }

  return docketRow;
}